<template>
  <el-dialog class="impersonate" title="Changer de compte" :visible.sync="visible" :close-on-click-modal="false" @open="open" @close="close">
    <div v-loading="loading">
      <div class="row imitator" v-if="imitator()" @click="desimpersonate()">
        <div class="col-xs-3">
          <gravatar class="img-thumbnail" :email="imitator().email"></gravatar>
        </div>
        <div class="col-xs-9">
          <strong>{{ imitator().name }}</strong> (id {{ imitator().id }})
          <div>{{ imitator().email }}</div>
          <!--<div><strong>Rôle</strong> : {{ user.role_type }}</div>-->
        </div>
      </div>

      <div class="row" v-for="user in users" :key="user.id" @click="impersonate(user)">
        <div class="col-xs-3">
          <gravatar class="img-thumbnail" :email="user.email"></gravatar>
        </div>
        <div class="col-xs-9">
          <strong>{{ user.name }}</strong> (id {{ user.id }})
          <div>{{ user.email }}</div>
          <!--<div><strong>Rôle</strong> : {{ user.role_type }}</div>-->
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import nexus from '@db2b/nexus-js'
  import ls from 'local-storage'
  import gravatar from 'vue-gravatar'
  import { events } from '../../services/event-bus.js'

  export default {
    name: 'impersonate-modal',
    components: {
      gravatar
    },
    data () {
      return {
        loading: false,
        visible: false,
        users: []
      }
    },
    created () {
      let self = this

      events.on('app/ui/impersonate', () => {
        self.visible = true
      })
    },
    methods: {
      imitator () {
        return ls.get('imitator') ? ls.get('imitator').user : null
      },
      desimpersonate () {
        nexus.setToken(ls.get('imitator').token)
        ls.remove('imitator')
        window.location.reload()
      },
      impersonate (user) {
        let self = this

        this.loading = true
        nexus.post('account', 'token/impersonate/' + user.id)
          .then(response => {
            ls.set('imitator', {
              token: nexus.getToken(),
              user: self.$store.getters['users/current']
            })
            nexus.setToken(response.data.token)
            window.location.reload()
          })
      },
      open () {
        let self = this

        self.loading = true
        nexus.get('account', 'token/impersonations')
          .then(response => {
            self.loading = false
            self.users = response.data.data
          })
      },
      close () {
        this.users = []
      }
    }
  }
</script>

<style>
  .impersonate .el-dialog {
    width: 420px;
  }

  .impersonate .row:first-child {
    margin-top: 0;
  }

  .impersonate .row {
    padding: 11px 1px;
    margin: 10px 0;
    cursor: pointer;
  }

  .impersonate .row:hover {
    padding: 10px 0px;
    border: 1px solid rgba(100, 176, 242, 0.6);
    background-color: rgba(100, 176, 242, 0.2);
  }

  .impersonate .row.imitator:hover {
    padding: 10px 0px;
    border: 1px solid rgba(27, 185, 154, 0.6);
    background-color: rgba(27, 185, 154, 0.2);
  }
</style>



// WEBPACK FOOTER //
// ImpersonateModal.vue?94894ea0